import React from 'react';
import './dark-header.css';

export default function DarkHeader() {
  return (
    <section className="dark-header">
      <h1 className="dark-header-h1">Chord Courier</h1>
      <h2 className="dark-header-h2">Delivering fresh chords</h2>
    </section>
  );
}
